module.exports = ".responseOptions .key {\n  border-style: none;\n  border-bottom-style: solid;\n  margin-top: 0.5em; }\n\n.responseOptions .value {\n  margin-left: 1em; }\n\n.addResponseBtn {\n  margin-top: 1em;\n  margin-left: 2em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/polls/createpoll.component.scss
// module id = 347
// module chunks = 1